function mapWidget() {
    const mapRoot = document.querySelector('#locationMap');
    if (!mapRoot || !mapRoot.dataset.coordinates) return;

    ymaps.ready(function () {
        var myMap = new ymaps.Map('locationMap', {
            center: JSON.parse(mapRoot.dataset.coordinates).reverse(),
            zoom: 16,
            controls: ['zoomControl']
        }),

            myPlacemark = new ymaps.Placemark(myMap.getCenter(), {},);

        myMap.geoObjects.add(myPlacemark)
    });

}

export default mapWidget;
